class SourceAddressBuilder {
    // setOnError(error) {
    //     this.onError = error;

    //     throw error;
    // }

    setStateOrProvince(state) {
        this.stateOrProvince = state;

        return this;
    }

    setStreet(street) {
        this.street = street;

        return this;
    }

    setHouseNumberOrName(number) {
        this.houseNumberOrName = number;

        return this;
    }

    setCity(city) {
        this.city = city;

        return this;
    }

    setCountry(country) {
        this.country = country;

        return this;
    }

    setPostalCode(postalCode) {
        this.postalCode = postalCode;

        return this;
    }

    build() {
        return {
            billingAddress: {
                ...this,
            },
        };
    }
}

export default SourceAddressBuilder;
